import React, { Fragment, useEffect } from "react";

import AhoyEvent from "shared/ahoy_event";
import { ActiveLanguage } from 'shared/vidio_helpers';
import LivestreamingCountdown from 'components/shared/LivestreamingCountdown/LivestreamingCountdown'

export function BottomSheet({ schedule, livestreaming }) {
  const ahoyTitle = "LIVESTREAMING";
  const ahoyProps = {
    action: 'impression',
    content_id: parseInt(schedule.id),
    content_type: 'schedule',
    source_content_id: parseInt(livestreaming.id),
    feature: 'upcoming schedule',
  };

  const month_names = {
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    id: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
  };

  useEffect(() => {
    let eventTitle = AhoyEvent.getEventTitle(ahoyTitle);
    let eventData = AhoyEvent.generateEventData(ahoyProps);

    AhoyEvent.send(eventTitle, eventData);

    let element = document.querySelector('.bottom-sheet__footer');
    let countdown = new LivestreamingCountdown({ element: element });
    countdown.init();

    calculateScrollbar();
  }, []);

  const countdownMessage = () => {
    let lang = ActiveLanguage.get();
    return window.Locale[lang].livestreaming.countdown_message;
  }

  const countdownTime = () => {
    return (new Date(schedule.start_time)).getTime() / 1000;
  }

  const calculateScrollbar = () => {
    let description = document.querySelector('.bottom-sheet__description');
    if (description.scrollHeight <= 95) {
      return;
    }
    description.classList.remove('bottom-sheet__description_default');
    document.querySelector('.bottom-sheet__body').classList.add('bottom-sheet__body_scrollable');
  }

  const formatDate = (dateString) => {
    let date = new Date(dateString);

    let lang = ActiveLanguage.get();
    let day = window.Locale[lang].date.day_names[date.getDay()];
    let month = month_names[lang][date.getMonth()];

    let hour = padedTime(date.getHours());
    let minute = padedTime(date.getMinutes());

    return `${day}, ${date.getDate()} ${month} ${date.getFullYear()}・${hour}:${minute}`;
  }

  const padedTime = (value) => {
    if (value <= 0) {
      return '00';
    }
    if (value < 10) {
      return '0' + value;
    }
    return '' + value;
  }

  return (
    <Fragment>
      <div className="bottom-sheet__body">
        <img src={schedule.thumbnail_url} className="bottom-sheet__image"/>
        <div className="bottom-sheet__header">
          <span className="bottom-sheet__user">{livestreaming.title}</span>
          <h4 className="bottom-sheet__title">{schedule.title}</h4>
          <p className="bottom-sheet__date">{formatDate(schedule.start_time)}</p>
        </div>
        <p className="bottom-sheet__description bottom-sheet__description_default">{schedule.description}</p>
      </div>
      <div className="bottom-sheet__footer" data-livestreaming-start={countdownTime()} data-reload-page='true'>
        <span>{countdownMessage()}</span>
        <span className="bottom-sheet__footer-date ls-countdown-timer"></span>
      </div>
    </Fragment>
  );
}
